import { AxiosRequestConfig } from 'axios';
import PatientService from './PatientService';
import urls from '../util/urls';
import { ServiceAuth } from '../hooks/useService/useService';

export class CarePlanService {
  api: PatientService;
  constructor(options?: Partial<AxiosRequestConfig>) {
    this.api = new PatientService(options);
  }

  listCarePlans =
    (auth: ServiceAuth) =>
    async (patientId: string, cohort?: string, projectId?: string) => {
      return await this.api.PatientAPI(auth).get<fhir.Bundle>(
        urls.api.fhir.carePlan({
          account: auth.account,
          params: {
            subject: patientId,
            cohort,
            _tag: `http://lifeomic.com/fhir/dataset|${projectId}`,
          },
        }),
      );
    };

  fetchCarePlan = (auth: ServiceAuth) => async (id: string) => {
    return await this.api
      .PatientAPI(auth)
      .get<fhir.CarePlan>(
        urls.api.fhir.carePlan({ id, account: auth.account }),
      );
  };

  createCarePlan =
    (auth: ServiceAuth) => (carePlan: fhir.CarePlan, cohort?: string) => {
      return this.api
        .PatientAPI(auth)
        .post<fhir.CarePlan>(
          urls.api.fhir.carePlan({ account: auth.account }),
          carePlan,
          {
            params: {
              cohort,
            },
          },
        );
    };

  saveCarePlan =
    (auth: ServiceAuth) =>
    (id: string, carePlan: fhir.CarePlan, cohort?: string) => {
      const headers: Record<string, string> = {};

      if (carePlan.meta?.versionId) {
        headers['If-Match'] = carePlan.meta.versionId;
      }

      return this.api
        .PatientAPI(auth)
        .put(urls.api.fhir.carePlan({ id, account: auth.account }), carePlan, {
          headers,
          params: {
            cohort,
          },
        });
    };
}
